<template>
  <div class="home-box" ref="scrollContainer">
    <div ref="ref1" class="home-title-box">
      <div class="video-background">
          <video playsinline autoplay muted loop>
            <!-- <source src="./../assets/video/video.mp4" type="video/mp4"> -->
            <source src="https://qiniu.jshtcq.com/video.mp4" type="video/mp4">
          </video>
      </div>
      <div class="home-top-box">
        <div class="home-top-title">
          <img class="home-top-title-img" src="./../assets/jsht/home/ksrk.png" alt />
          <div class="home-top-title-search">
            <input class="home-top-title-search-input" type="text" v-model="input" placeholder="请输入关键词" />
            <div @click="toKsrk()" class="home-top-title-search-button">
              <img src="./../assets/jsht/home/形状结合.png" alt />
              <span >搜索</span>
            </div>
          </div>
        </div>
        <div class="home-top-content">
          <div v-for="(item, index) of ksrkList" :key="index" class="home-top-content-item" @click="toPage(item.path)">
            <img :src="item.imgUrl" alt />
            <div class="home-top-content-item-text">
              <div class="home-top-content-item-text-title">{{ item.title }}</div>
              <div class="home-top-content-item-text-tip">{{ item.tip }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="ref2">
      <img class="title-img" src="./../assets/jsht/home/xmtj_title.png" alt />
      <div class="swiper-box">
        <div class="swiper-prev" @click="swiperPrev">
          <img src="./../assets/jsht/home/swiper_left.png" alt />
        </div>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div v-for="(i, index) of wrapperList" :key="index" @click="viewXmDetail(i)" class="swiper-slide">
              <div class="swiper-slide-img-box">
                <img :src="i.tp" alt />
              </div>
              <div class="swiper-slide-text-box">
                <span class="swiper-slide-text-tag">{{ i.lxmc }}</span>
                {{ i.bt }}
              </div>
            </div>
          </div>
          <!-- Add Pagination -->
          <!-- Add Navigation -->
        </div>

        <div class="swiper-next" @click="swiperNext">
          <img src="./../assets/jsht/home/swiper_right.png" alt />
        </div>
      </div>
      <!-- <div class="xmtj-more">查看更多</div> -->
      <img class="title-img" src="./../assets/jsht/home/xmdt_title.png" alt />
      <div class="xmdt-box">
        <div class="xmdt-table-item">
          <div class="xmdt-table-item-title">
            <div class="xmdt-table-item-title-left">
              <img src="./../assets/jsht/home/xmdt_title_left_img.png" alt />
              资产转让
            </div>
            <div class="xmdt-table-item-title-right" @click="toPage(`/xm/zczr/${zczrIndex}`)">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="xmdt-table-item-detail">
            <div class="xmdt-table-item-detail-left">
              <div :class="['xmdt-table-item-detail-left-tab', zczrIndex === item.category ? 'active' : '']"
                v-for="(item, index) of zczrList" :key="index" @click="getXmdtZczr(item.category)">
                <img :src="zczrIndex === item.category ? item.activeImg : item.unActiveImg" alt />
                {{ item.text }}
              </div>
            </div>
            <div class="xmdt-table-item-detail-right">
              <el-table header-cell-class-name="table-header-own" :data="zczrTableData" stripe style="width: 100%">
                <el-table-column prop="bt" align="center"  label="项目名称" show-overflow-tooltip min-width="260">
                  <template slot-scope="scope"> 
                    <el-link type="primary" @click.native.prevent="viewXmDetail(scope.row)" :underline="false">{{scope.row.bt}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="gpj" label="转让底价" min-width="60"></el-table-column>
                <el-table-column align="center" prop="bmjzsj" min-width="80" label="挂牌结束日期"></el-table-column>
                <el-table-column align="center" prop="readNum" min-width="60" label="点击量"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="viewXmDetail(scope.row)" type="warning"
                      size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="xmdt-table-item">
          <div class="xmdt-table-item-title">
            <div class="xmdt-table-item-title-left">
              <img src="./../assets/jsht/home/xmdt_title_left_img.png" alt />
              资产租赁
            </div>
            <div class="xmdt-table-item-title-right" @click="toPage(`/xm/zczl/${zczlIndex}`)">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="xmdt-table-item-detail">
            <div class="xmdt-table-item-detail-left">
              <div :class="['xmdt-table-item-detail-left-tab', zczlIndex === item.category ? 'active' : '']"
                v-for="(item, index) of zczlList" :key="index" @click="getXmdtZczl(item.category)">
                <img :src="zczlIndex === item.category ? item.activeImg : item.unActiveImg" alt />
                {{ item.text }}
              </div>
            </div>
            <div class="xmdt-table-item-detail-right">
              <el-table header-cell-class-name="table-header-own" :data="zczlTableData" stripe style="width: 100%">
                <el-table-column prop="bt" align="center" label="项目名称" show-overflow-tooltip min-width="260">
                  <template slot-scope="scope"> 
                    <el-link type="primary" @click.native.prevent="viewXmDetail(scope.row)" :underline="false">{{scope.row.bt}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="gpj" label="出租底价" min-width="60"></el-table-column>
                <el-table-column align="center" prop="bmjzsj" min-width="100" label="挂牌结束日期"></el-table-column>
                <el-table-column align="center" prop="readNum" min-width="60" label="点击量"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="viewXmDetail(scope.row)" type="warning"
                      size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="xmdt-table-item">
          <div class="xmdt-table-item-title">
            <div class="xmdt-table-item-title-left">
              <img src="./../assets/jsht/home/xmdt_title_left_img.png" alt />
              综合交易
            </div>
            <div class="xmdt-table-item-title-right" @click="toPage(`/xm/zhjy/${zhjyIndex}`)">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="xmdt-table-item-detail">
            <div class="xmdt-table-item-detail-left">
              <div :class="['xmdt-table-item-detail-left-tab', zhjyIndex === item.category ? 'active' : '']"
                v-for="(item, index) of zhjyList" :key="index" @click="getXmdtZhjy(item.category)">
                <img :src="zhjyIndex === item.category ? item.activeImg : item.unActiveImg" alt />
                {{ item.text }}
              </div>
            </div>
            <div class="xmdt-table-item-detail-right">
              <el-table header-cell-class-name="table-header-own" :data="zhjyTableData" stripe style="width: 100%">
                <el-table-column prop="bt" align="center" label="项目名称" show-overflow-tooltip min-width="260">
                  <template slot-scope="scope"> 
                    <el-link type="primary" @click.native.prevent="viewXmDetail(scope.row)" :underline="false">{{scope.row.bt}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="gpj" label="转让底价" min-width="60"></el-table-column>
                <el-table-column align="center" prop="bmjzsj" min-width="80" label="挂牌结束日期"></el-table-column>
                <el-table-column align="center" prop="readNum" min-width="60" label="点击量"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="viewXmDetail(scope.row)" type="warning"
                      size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="xmdt-table-item">
          <div class="xmdt-table-item-title">
            <div class="xmdt-table-item-title-left">
              <img src="./../assets/jsht/home/xmdt_title_left_img.png" alt />
              农村产权
            </div>
            <div class="xmdt-table-item-title-right" @click="toPage(`/xm/nccq/${nccqIndex}`)">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="xmdt-table-item-detail">
            <div class="xmdt-table-item-detail-left">
              <div :class="['xmdt-table-item-detail-left-tab', nccqIndex === item.category ? 'active' : '']"
                v-for="(item, index) of nccqList" :key="index" @click="getXmdtNccq(item.category)">
                <img :src="nccqIndex === item.category ? item.activeImg : item.unActiveImg" alt />
                {{ item.text }}
              </div>
            </div>
            <div class="xmdt-table-item-detail-right">
              <el-table header-cell-class-name="table-header-own" :data="nccqTableData" stripe style="width: 100%">
                <el-table-column prop="bt" align="center" label="项目名称" show-overflow-tooltip min-width="260">
                  <template slot-scope="scope"> 
                    <el-link type="primary" @click.native.prevent="viewXmDetail(scope.row)" :underline="false">{{scope.row.bt}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="gpj" label="挂牌价格" min-width="60"></el-table-column>
                <el-table-column align="center" prop="bmjzsj" min-width="80" label="挂牌结束日期"></el-table-column>
                <el-table-column align="center" prop="readNum" min-width="60" label="点击量"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="viewXmDetail(scope.row)" type="warning"
                      size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- <div class="xmdt-table-item">
        <div class="xmdt-table-item-title">
          <div class="xmdt-table-item-title-left">
            <img src="./../assets/jsht/home/xmdt_title_left_img.png" alt="">
            阳光招标
          </div>
          <div class="xmdt-table-item-title-right">
            更多
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="xmdt-table-item-detail">
          <div class="xmdt-table-item-detail-left">
            <div :class="['xmdt-table-item-detail-left-tab', ygzbIndex === item.category ? 'active' : '']"
              v-for="(item, index) of ygzbList" :key="index">
              <img :src="ygzbIndex === item.category ? item.activeImg : item.unActiveImg" alt="">
              {{ item.text }}
            </div>
          </div>
          <div class="xmdt-table-item-detail-right">
            <el-table header-cell-class-name="table-header-own" :data="ygzbTableData" stripe style="width: 100%">
              <el-table-column prop="bt" align="center" label="项目名称" min-width="180">
              </el-table-column>
              <el-table-column align="center" prop="gpj" label="转让底价" min-width="100">
              </el-table-column>
              <el-table-column align="center" prop="bmjzsj" min-width="100" label="挂牌结束日期">
              </el-table-column>
              <el-table-column align="center" prop="readNum" min-width="80" label="点击量">
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="viewXmDetail(scope.row)" type="warning" size="small">
                    查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        </div>-->
        <!-- <div class="xmdt-table-item">
          <div class="xmdt-table-item-title">
            <div class="xmdt-table-item-title-left">
              <img src="./../assets/jsht/home/xmdt_title_left_img.png" alt />
              成交公示
            </div>
            <div class="xmdt-table-item-title-right" @click="toPage(`/xm/cjgs/${cjgsIndex}`)">
              更多
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="xmdt-table-item-detail">
            <div class="xmdt-table-item-detail-left">
              <div :class="['xmdt-table-item-detail-left-tab', cjgsIndex === item.category ? 'active' : '']"
                v-for="(item, index) of cjgsList" :key="index" @click="getXmdtCjgs(item.category)">
                <img :src="cjgsIndex === item.category ? item.activeImg : item.unActiveImg" alt />
                {{ item.text }}
              </div>
            </div>
            <div class="xmdt-table-item-detail-right">
              <el-table header-cell-class-name="table-header-own" :data="cjgsTableData" stripe style="width: 100%">
                <el-table-column prop="bt" align="center" label="项目名称" show-overflow-tooltip min-width="260">
                  <template slot-scope="scope"> 
                    <el-link type="primary" @click.native.prevent="viewXmDetail(scope.row)" :underline="false">{{scope.row.bt}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="gpj" label="成交价" min-width="60"></el-table-column>
                <el-table-column align="center" prop="bmjzsj" min-width="80" label="挂牌结束日期"></el-table-column>
                <el-table-column align="center" prop="readNum" min-width="60" label="点击量"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="viewXmDetail(scope.row)" type="warning"
                      size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div> -->
      </div>
      <img class="title-img" src="./../assets/jsht/home/zxdt_title.png" alt />
      <div class="zxdt-box">
        <div class="zxdt-box-img">
          <div class="swiper-wrapper">
            <div v-for="item of tpzxdtList" :key="item.noticeId" class="swiper-slide" @click="toDtdetail(item)">
              <img :src="item.img" alt />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div class="zxdt-box-detail">
          <div class="zxdt-box-detail-tab">
            <div :class="['zxdt-box-detail-tab-item', zxdtIndex === 1 ? 'active' : '']" @click="getZxdt(1)">
              公司动态
              <div class="zxdt-box-detail-tab-item-line"></div>
            </div>
            <div :class="['zxdt-box-detail-tab-item', zxdtIndex === 2 ? 'active' : '']" @click="getZxdt(2)">
              行业资讯
              <div class="zxdt-box-detail-tab-item-line"></div>
            </div>
            <div :class="['zxdt-box-detail-tab-item', zxdtIndex === 3 ? 'active' : '']" @click="getZxdt(3)">
              通知公告
              <div class="zxdt-box-detail-tab-item-line"></div>
            </div>
          </div>
          <div class="zxdt-box-detail-list">
            <div @click="toDtdetail(e)" class="zxdt-box-detail-list-item" v-for="(e, i) of zxdtList" :key="i">
              <div class="zxdt-box-detail-list-item-left">{{ e.title }}</div>
              <div class="zxdt-box-detail-list-item-right">{{ e.createtime }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="xmtj-more" @click="toPage(`/zx/${zxdtPage}/${zxdtIndex}`)">查看更多</div>
      <img class="title-img" src="./../assets/jsht/home/yqlj_title.png" alt />
      <div class="yqlj-box">
        <div class="yqlj-item" v-for="(item,index) of yqljList" :key="index">
          <a :href="item.href" target="_blank">
            <img :src="item.img" alt="" style="width: 90%;">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules';
import _ from 'lodash'
export default {
  components: {},
  data() {
    return {
      input: '',
      ksrkList: [
        {
          imgUrl: require('./../assets/jsht/home/资产转让.png'),
          title: '资产转让',
          tip: '房产、土地、实物资产等转让',
          path: '/xm/zczr'
        },
        {
          imgUrl: require('./../assets/jsht/home/资产租赁.png'),
          title: '资产租赁',
          tip: '商铺、办公楼、厂房等招租',
          path: '/xm/zczl'
        },
        {
          imgUrl: require('./../assets/jsht/home/综合交易.png'),
          title: '综合交易',
          tip: '企业债权、特许经营权等转让',
          path: '/xm/zhjy'
        },
        {
          imgUrl: require('./../assets/jsht/home/农村产权.png'),
          title: '农村产权',
          tip: '农村集体产权等交易',
          path: '/xm/nccq'
        },
        {
          imgUrl: require('./../assets/jsht/home/招商推介.png'),
          title: '招商推介',
          tip: '项目预招商、市场推介',
          path: '/xm/zstj'
        },
        {
          imgUrl: require('./../assets/jsht/home/阳光招标.png'),
          title: '阳光招标',
          tip: '工程采购等公开招投标',
          path: '/xm/ygzb'
        }
      ],
      wrapperList: [],
      swiperItem: null,
      imgSwiper: null,
      zczrList: [
        {
          category: 1,
          activeImg: require('./../assets/jsht/房屋1.png'),
          unActiveImg: require('./../assets/jsht/房屋0.png'),
          text: '房屋'
        },
        {
          category: 2,
          activeImg: require('./../assets/jsht/设备1.png'),
          unActiveImg: require('./../assets/jsht/设备0.png'),
          text: '设备物资'
        },
        // {
        //   category:3,
        //   activeImg: require('./../assets/jsht/物资1.png'),
        //   unActiveImg: require('./../assets/jsht/物资0.png'),
        //   text: '物资'
        // },
        {
          category: 3,
          activeImg: require('./../assets/jsht/机动车1.png'),
          unActiveImg: require('./../assets/jsht/机动车0.png'),
          text: '车辆'
        },
        {
          category: 4,
          activeImg: require('./../assets/jsht/其他1.png'),
          unActiveImg: require('./../assets/jsht/其他0.png'),
          text: '其他'
        }
      ],
      zczrIndex: 1,
      zczrTableData: [],
      zczlList: [
        {
          category: 5,
          activeImg: require('./../assets/jsht/房屋1.png'),
          unActiveImg: require('./../assets/jsht/房屋0.png'),
          text: '房屋'
        },
        // {
        //   category:7,
        //   activeImg: require('./../assets/jsht/土地1.png'),
        //   unActiveImg: require('./../assets/jsht/土地0.png'),
        //   text: '土地'
        // },
        {
          category: 6,
          activeImg: require('./../assets/jsht/场地区域1.png'),
          unActiveImg: require('./../assets/jsht/场地区域0.png'),
          text: '场地区域'
        },
        {
          category: 7,
          activeImg: require('./../assets/jsht/场地区域1.png'),
          unActiveImg: require('./../assets/jsht/场地区域0.png'),
          text: '设备'
        },
        {
          category: 8,
          activeImg: require('./../assets/jsht/其他1.png'),
          unActiveImg: require('./../assets/jsht/其他0.png'),
          text: '其他'
        }
      ],
      zczlIndex: 5,
      zczlTableData: [],
      zhjyList: [
        {
          category: 9,
          activeImg: require('./../assets/jsht/特许经营权1.png'),
          unActiveImg: require('./../assets/jsht/特许经营权0.png'),
          text: '特许经营权'
        },
        {
          category: 10,
          activeImg: require('./../assets/jsht/债券1.png'),
          unActiveImg: require('./../assets/jsht/债券0.png'),
          text: '债权'
        },
        {
          category: 11,
          activeImg: require('./../assets/jsht/数据信息1.png'),
          unActiveImg: require('./../assets/jsht/数据信息0.png'),
          text: '数据信息'
        },
        {
          category: 12,
          activeImg: require('./../assets/jsht/专栏1.png'),
          unActiveImg: require('./../assets/jsht/专栏0.png'),
          text: '专栏'
        }
      ],
      zhjyIndex: 9,
      zhjyTableData: [],
      nccqList: [
        {
          category: 13,
          activeImg: require('./../assets/jsht/房屋1.png'),
          unActiveImg: require('./../assets/jsht/房屋0.png'),
          text: '房屋'
        },
        {
          category: 14,
          activeImg: require('./../assets/jsht/土地1.png'),
          unActiveImg: require('./../assets/jsht/土地0.png'),
          text: '土地'
        },
        {
          category: 15,
          activeImg: require('./../assets/jsht/设备1.png'),
          unActiveImg: require('./../assets/jsht/设备0.png'),
          text: '设备'
        },
        {
          category: 16,
          activeImg: require('./../assets/jsht/其他1.png'),
          unActiveImg: require('./../assets/jsht/其他0.png'),
          text: '其他'
        }
      ],
      nccqIndex: 13,
      nccqTableData: [],
      // ygzbList: [
      //   {
      //     category:17,
      //     activeImg: require('./../assets/jsht/房屋1.png'),
      //     unActiveImg: require('./../assets/jsht/房屋0.png'),
      //     text: '工程项目'
      //   },
      //   {
      //     category:18,
      //     activeImg: require('./../assets/jsht/土地1.png'),
      //     unActiveImg: require('./../assets/jsht/土地0.png'),
      //     text: '采购项目'
      //   },
      // ],
      // ygzbIndex: 17,
      // ygzbTableData: [],
      cjgsList: [
        {
          category: 19,
          activeImg: require('./../assets/jsht/成交公示1.png'),
          unActiveImg: require('./../assets/jsht/成交公示0.png'),
          text: '成交公示'
        }
      ],
      cjgsIndex: 19,
      cjgsTableData: [],
      zxdtIndex: 1,
      zxdtList: [],
      zxdtPage: 'gsdt',
      scrollTop: 0,
      scrollHeight: null,
      tpzxdtList: [],
      yqljList:[{
        img:require('./../assets/jsht/home/yqlj_1.png'),
        href:'http://www.wxbhggzy.com/'
      },{
        img:require('./../assets/jsht/home/yqlj_2.png'),
        href:'http://ggzyjy.wuxi.gov.cn/'
      },{
        img:require('./../assets/jsht/home/yqlj_3.png'),
        href:'https://zcpm.jd.com/gov'
      },{
        img:require('./../assets/jsht/home/yqlj_4.png'),
        href:'http://njggzy.nanjing.gov.cn/njweb/'
      }],
      isVisible1:false,
      isVisible2:false
    }
  },
  watch: {
    scrollTop(newVal, oldVal) {
      console.log(this.scrollTop)
      if (newVal > oldVal) {
        if(this.isVisible1&&this.isVisible2){
          window.scrollTo({ top: this.scrollHeight, behavior: 'smooth' })
        }
        // if (this.scrollTop < 100) {
        //   window.scrollTo({ top: this.scrollHeight, behavior: 'smooth' })
        // }
      } else if (newVal < oldVal) {
        if(this.isVisible1){
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
        // if (this.scrollTop < this.scrollHeight) {
        //   window.scrollTo({ top: 0, behavior: 'smooth' })
        // }
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    // window.addEventListener('scroll', _.throttle(this.handleScroll,3000));
    this.scrollHeight = window.innerHeight - this.$refs.ref1.offsetTop
    this.$el
      .querySelector('.zxdt-box-img')
      .addEventListener('mouseenter', () => {
        this.imgSwiper.autoplay.stop() // 鼠标进入时停止自动轮播
      })
    this.$el
      .querySelector('.zxdt-box-img')
      .addEventListener('mouseleave', () => {
        this.imgSwiper.autoplay.start() // 鼠标离开时开始自动轮播
      })
    this.getXmtj()
    this.getXmdtZczr(this.zczrIndex)
    this.getXmdtZczl(this.zczlIndex)
    this.getXmdtZhjy(this.zhjyIndex)
    this.getXmdtNccq(this.nccqIndex)
    this.getXmdtCjgs(this.cjgsIndex)
    this.getZxdt(this.zxdtIndex)
    this.getImg()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      this.scrollTop = scrollTop
      const rect1 = this.$refs.ref1.getBoundingClientRect();
      const isVisible1 = (
        rect1.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect1.bottom-80 >= 0
      );
      this.isVisible1 = isVisible1
      const rect2 = this.$refs.ref2.getBoundingClientRect();
      const isVisible2 = (
        rect2.top-20 <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect2.bottom >= 0
      );
      this.isVisible2 = isVisible2

      console.log(isVisible2)
      //  return _.throttle(this.setScrollTop, 5000); // 1000毫秒内最多执行一次handleResize函数
      // 在这里添加你的滚动处理逻辑
    },
    toKsrk(){
      this.$router.push({
        path: '/xm/ksrk',
        query:{
          searchInput:this.input
        }
      })
    },
    toPage(path) {
      this.$router.push({
        path: path
      })
    },
    viewXmDetail(row) {
      this.$router.push({
        path: `/detailInfo/${row.xmId}`
      })
    },
    getXmtj() {
      this.axios.get('https://admin.jshtcq.com/api/sy/xmtjlist').then(res => {
        this.wrapperList = res.data.data
        this.$nextTick(() => {
          this.swiperItem = new Swiper('.swiper-container', {
            // Swiper options
            loop: true,
            slidesPerView: '4',
            navigation: {
              nextEl: '.swiper-next',
              prevEl: '.swiper-prev'
            }
          })
        })
      })
    },
    getXmdtZczr(category) {
      this.zczrIndex = category
      let params = {
        category: category
      }
      this.axios
        .get('https://admin.jshtcq.com/api/sy/xmdtlist', { params })
        .then(res => {
          this.zczrTableData = res.data.data
        })
    },
    getXmdtZczl(category) {
      this.zczlIndex = category
      let params = {
        category: category
      }
      this.axios
        .get('https://admin.jshtcq.com/api/sy/xmdtlist', { params })
        .then(res => {
          this.zczlTableData = res.data.data
        })
    },
    getXmdtZhjy(category) {
      this.zhjyIndex = category
      let params = {
        category: category
      }
      this.axios
        .get('https://admin.jshtcq.com/api/sy/xmdtlist', { params })
        .then(res => {
          this.zhjyTableData = res.data.data
        })
    },
    getXmdtNccq(category) {
      this.nccqIndex = category
      let params = {
        category: category
      }
      this.axios
        .get('https://admin.jshtcq.com/api/sy/xmdtlist', { params })
        .then(res => {
          this.nccqTableData = res.data.data
        })
    },
    getXmdtCjgs(category) {
      this.cjgsIndex = category
      let params = {
        category: category
      }
      this.axios
        .get('https://admin.jshtcq.com/api/sy/xmdtlist', { params })
        .then(res => {
          this.cjgsTableData = res.data.data
        })
    },
    getZxdt(category) {
      if (category === 1) {
        this.zxdtPage = 'gsdt'
      } else if (category === 2) {
        this.zxdtPage = 'hyzx'
      } else if (category === 3) {
        this.zxdtPage = 'tzgg'
      }
      this.zxdtIndex = category
      let params = {
        category: category
      }
      this.axios
        .get('https://admin.jshtcq.com/api/sy/zxdtlist', { params })
        .then(res => {
          this.zxdtList = res.data.data
        })
    },
    swiperPrev() {
      this.swiperItem.slidePrev()
    },
    swiperNext() {
      this.swiperItem.slideNext()
    },
    getImg() {
      this.axios.get('https://admin.jshtcq.com/api/sy/tpzxdtlist').then(res => {
        this.tpzxdtList = res.data.data
        this.$nextTick(() => {
          this.imgSwiper = new Swiper('.zxdt-box-img', {
            // Swiper options
            loop: true,
            modules: [Autoplay],
            autoplay: {
              delay: 2500, // 自动切换的时间间隔
              disableOnInteraction: true // 如果用户与滑块交互，则停止自动播放
            }
          })
        })
      })
    },
    toDtdetail(row) {
      this.$router.push({
        path: `/messageDetail/${row.noticeId}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-title-box {
  // background: url('./../assets/jsht//home/full_bg.jpg') left top no-repeat;
  // background-size: 100% 100%;
  width: 100%;
  height: calc(100vh - 80px);
  border-top: 1px solid #ffffff;
  position: relative;
  .video-background{
    position: absolute; /* 或者 absolute，根据需要 */
    right: 0;
    bottom: 0;
    width: 100%; 
    height: 100%;
    z-index: 20; /* 确保视频在内容之下 */
    overflow: hidden;
    video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    }
  }
  .home-top-box {
    width: 1440px;
    height: 302px;
    background: rgba(255,255,255,0.8);
    box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.11);
    border-radius: 8px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 100;
    position: absolute;
    .home-top-title {
      height: 70px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 32px;
      box-shadow: 0px 1px 0px 0px #dedee5;

      .home-top-title-img {
        width: 133px;
        height: 34px;
      }

      .home-top-title-search {
        width: 443px;
        height: 42px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #0c6aec;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 2px 2px 2px 18px;

        .home-top-title-search-input {
          outline: none;
          border: none;
          flex: 1;
          height: 100%;
        }

        .home-top-title-search-button {
          width: 98px;
          height: 34px;
          background: #0c6aec;
          border-radius: 6px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
          cursor: pointer;
          img {
            width: 19px;
            height: 19px;
            margin-right: 8px;
          }
        }
      }
    }

    .home-top-content {
      padding: 36px 84px;
      height: 232px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-content: space-between;
      flex-wrap: wrap;

      .home-top-content-item {
        width: 33.33%;
        height: 61px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        img {
          width: 61px;
          height: 61px;
        }

        .home-top-content-item-text {
          margin-left: 16px;

          .home-top-content-item-text-title {
            font-weight: bold;
            font-size: 22px;
            color: #1e1e1e;
            height: 22px;
            line-height: 22px;
          }

          .home-top-content-item-text-tip {
            font-weight: 400;
            font-size: 16px;
            color: #898989;
            margin-top: 16px;
            height: 16px;
            line-height: 16px;
          }
        }
      }
    }
  }
}

.home-box {
  // background: url('./../assets/jsht//home/andreas-brucker-g5Uh7nP60FA-unsplash.png') left top no-repeat;
  background-size: 100% auto;
  background-color: #f7f7f7;
  overflow: auto;


  .title-img {
    display: block;
    margin: 60px auto 40px auto;
    width: 210px;
    height: 37px;
  }

  .swiper-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    height: 370px;

    .swiper-prev {
      cursor: pointer;

      img {
        width: 46px;
        height: 47px;
      }

      margin-right: 12px;
    }

    .swiper-next {
      cursor: pointer;

      img {
        width: 46px;
        height: 47px;
      }

      margin-left: 12px;
    }

    .swiper-container {
      width: 1440px;
      height: 370px;
      overflow: hidden;

      .swiper-wrapper {
        .swiper-slide {
          width: 352px !important;
          height: 370px;
          border: 1px solid #e2e2e2;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;

          &+.swiper-slide {
            margin-left: 12px;
          }

          .swiper-slide-img-box {
            width: 352px;
            height: 260px;

            // background: red;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .swiper-slide-text-box {
            line-height: 32px;
            color: #1e1e1e;
            font-size: 18px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 10px;
            padding: 0 12px;

            .swiper-slide-text-tag {
              display: inline-flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              height: 28px;
              width: 66px;
              text-align: center;
              background: rgba(255, 110, 37, 0.2);
              border-radius: 4px;
              border: 1px solid #ff6e25;
              font-size: 14px;
              color: #ff6e25;
            }
          }
        }
      }
    }
  }

  .xmtj-more {
    width: 170px;
    height: 46px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #bcbcc7;
    margin: 36px auto 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #0c6aec;
    cursor: pointer;
  }

  .xmdt-box {
    width: 1440px;
    margin: 0 auto;

    .xmdt-table-item {
      &+.xmdt-table-item {
        margin-top: 20px;
      }

      .xmdt-table-item-title {
        width: 1440px;
        height: 71px;
        background: url('./../assets/jsht/home/xmdt_title_bg.png') left top no-repeat;
        background-size: 100% 100%;
        padding: 0 30px 0 35px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .xmdt-table-item-title-left {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          font-size: 26px;
          color: #1e1e1e;
          font-weight: bold;

          img {
            width: 28px;
            height: 35px;
            margin-right: 12px;
          }
        }

        .xmdt-table-item-title-right {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          font-size: 18px;
          color: #0c6aec;
          cursor: pointer;
        }
      }

      .xmdt-table-item-detail {
        background: #ffffff;
        padding: 20px 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .xmdt-table-item-detail-left {
          width: 249px;

          .xmdt-table-item-detail-left-tab {
            &+.xmdt-table-item-detail-left-tab {
              margin-top: 10px;
            }

            width: 224px;
            height: 50px;
            cursor: pointer;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding-left: 32px;
            border-radius: 8px;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);

            &.active {
              color: #ffffff;
              background: #0c6aec;
            }

            img {
              width: 24px;
              height: 24px;
              margin-right: 20px;
            }
          }
        }

        .xmdt-table-item-detail-right {
          border: 1px solid #e8e8e8;
          flex: 1;

          ::v-deep {
            .table-header-own {
              font-size: 16px !important;
              color: #0c6aec !important;
              background: #e5f2ff !important;
            }
          }
        }
      }
    }
  }

  .zxdt-box {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .zxdt-box-img {
      width: 532px;
      height: 348px;
      background: #dfdfdf;
      overflow: hidden;

      .swiper-wrapper {
        width: 100%;
        height: 100%;

        .swiper-slide {
          width: 100%;
          height: 100%;
          overflow: hidden;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .zxdt-box-detail {
      flex: 1;
      height: 348px;
      margin-left: 20px;
      background: #ffffff;
      display: flex;
      flex-direction: column;

      .zxdt-box-detail-tab {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .zxdt-box-detail-tab-item {
          flex: 1;
          height: 60px;
          font-weight: 800;
          font-size: 18px;
          color: #6b6b6b;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          position: relative;
          cursor: pointer;

          &.active {
            color: #1e1e1e;
            background: #eff6ff;

            .zxdt-box-detail-tab-item-line {
              height: 6px;
              width: 100%;
              position: absolute;
              bottom: 0;
              background: #0c6aec;
            }
          }
        }
      }

      .zxdt-box-detail-list {
        flex: 1;
        overflow-y: auto;

        .zxdt-box-detail-list-item {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          height: 48px;
          padding: 0 15px;
          border-bottom: 1px solid #ebebeb;
          cursor: pointer;

          &:hover {
            background: #eff6ff;
          }

          .zxdt-box-detail-list-item-left {
            flex: 1;
            font-weight: 400;
            font-size: 16px;
            color: #1e1e1e;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            /* 限制行数为3 */
            overflow: hidden;
            margin-right: 20px;
          }

          .zxdt-box-detail-list-item-right {
            font-weight: 400;
            font-size: 14px;
            color: #898989;
          }
        }
      }
    }
  }

  .yqlj-box {
    width: 100%;
    background: #0c6aec;
    padding: 45px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;

    .yqlj-item {
      width: 13.4%;
      height: 87px;
      background: #ffffff;
      border-radius: 4px;
      margin: 8px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      a{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>